module.exports = __webpack_public_path__ + "img/visa-qr 3.1f80573e.png";